/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Einvoice_Candidates_TitleInputs */

const vi_einvoice_candidates_title = /** @type {(inputs: Einvoice_Candidates_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Hóa đơn tạo trên web MISA, chưa gắn đơn nào`)
};

/**

* @param {Einvoice_Candidates_TitleInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const einvoice_candidates_title = /** @type {((inputs?: Einvoice_Candidates_TitleInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Einvoice_Candidates_TitleInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_einvoice_candidates_title(inputs)
});